export default {
  'forgetpassword.forgetpassword': 'رمز عبور خود را فراموش کرده اید ؟',
  'forgetpassword.wrongemail': 'ایمیلی که وارد کرده اید اشتباه است',
  'forgetpassword.resetemail':
    'برای تنظیم مجدد رمز عبور ایمیل خود را وارد کنید',
  'forgetpassword.resetpassword': 'تنظیم رمز عبور',
};
